module.exports = "<template>\n    <b-field grouped>\n        <b-field label=\"Personal title\">\n            <b-select>\n                <option>Mr.</option>\n                <option>Ms.</option>\n            </b-select>\n        </b-field>\n        <b-field label=\"Name\" expanded>\n            <b-input></b-input>\n        </b-field>\n        <b-field label=\"Email\" expanded>\n            <b-input></b-input>\n        </b-field>\n    </b-field>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/field/examples/ExGroupExpanded.vue
// module id = 1396
// module chunks = 5